import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import './i18n';
import { initCatalyst } from './lib/catalyst';

// Suppress noisy Farm HMR warnings for lucide-react in dev mode
if (import.meta.env.DEV) {
  const originalWarn = console.warn;
  console.warn = (...args) => {
    if (typeof args[0] === 'string' && args[0].includes('lucide-react') && args[0].includes('registered twice')) {
      return;
    }
    originalWarn(...args);
  };
}
// Initialize error tracking before React mounts
initCatalyst();

const container = document.querySelector('#root') as Element;
const root = createRoot(container);

root.render(<App />);
